import { api } from './client';
import type { LibraryDocument, LibraryDocType, Paginated } from '@/types';

export const libraryApi = {
  async list(filters: { doc_type?: string; object?: number; search?: string } = {}): Promise<Paginated<LibraryDocument>> {
    const { data } = await api.get<Paginated<LibraryDocument>>('/library-documents/', { params: filters });
    return data;
  },
  async upload(payload: { title: string; doc_type: LibraryDocType; object?: number | null }, file: File): Promise<LibraryDocument> {
    const fd = new FormData();
    fd.append('title', payload.title);
    fd.append('doc_type', payload.doc_type);
    if (payload.object) fd.append('object', String(payload.object));
    fd.append('file', file);
    const { data } = await api.post<LibraryDocument>('/library-documents/', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data;
  },
  async remove(id: number): Promise<void> { await api.delete(`/library-documents/${id}/`); },
  async checkDuplicate(hash: string): Promise<boolean> {
    const { data } = await api.get<{ duplicate: boolean }>('/library-documents/check_duplicate/', { params: { hash } });
    return data.duplicate;
  },
};
